<!-- Footer -->
<footer class="page-footer font-small blue-grey lighten-5 success-color">
  <div style="background-color: #ff8c61">
    <div class="container">
      <!-- Grid row-->
      <div class="row py-4 d-flex align-items-center">
        <!-- Grid column -->
        <div
          class="h4 col-md-6 text-white col-lg-5 text-center text-md-left mb-4 mb-md-0"
        >
          <h6 class="mb-0">Get connected with us on social networks!</h6>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-6 col-lg-7 text-center text-md-right">
          <!-- Facebook -->
          <a class="fb-ic">
            <i class="fa fa-facebook-f text-white mr-4"> </i>
          </a>
          <!-- Twitter -->
          <a class="tw-ic">
            <i class="fa fa-twitter text-white mr-4"> </i>
          </a>
          <!-- Google +-->
          <a class="gplus-ic">
            <i class="fa fa-google-plus-g text-white mr-4"> </i>
          </a>
          <!--Linkedin -->
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row-->
    </div>
  </div>

  <!-- Footer Links -->
  <div class="container text-center text-md-left mt-5">
    <!-- Grid row -->
    <div class="row mt-3 dark-grey-text">
      <!-- Grid column -->
      <div class="col-md-3 col-lg-4 col-xl-3 mb-4">
        <!-- Content -->
        <h6 class="text-uppercase font-weight-bold success-color">
          Panchayat Details
        </h6>
        <hr
          class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />
        <p>
          Jharpokharia village is located in Sharata Tehsil of Mayurbhanj
          district in Odisha, India. It is situated 29km away from sub-district
          headquarter Sharata and 84km away from district headquarter Baripada
        </p>
      </div>
      <!-- Grid column -->

      <!-- Grid column -->

      <!-- Grid column -->

      <!-- Grid column -->
      <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
        <!-- Links -->
        <h6 class="text-uppercase font-weight-bold">Useful links</h6>
        <hr
          class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />
        <p>
          <a class="dark-grey-text" href="#!">Complain Register</a>
        </p>
        <p>
          <a class="dark-grey-text" href="#!">Complain Status</a>
        </p>
        <p>
          <a class="dark-grey-text" href="#!">Online Apply</a>
        </p>
        <p>
          <a class="dark-grey-text" href="#!">Help</a>
        </p>
      </div>
      <!-- Grid column -->

      <!-- Grid column -->
      <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
        <!-- Links -->
        <h6 class="text-uppercase font-weight-bold">Contact</h6>
        <hr
          class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />
        <p>
          <i class="fa fa-map-marker mr-3"></i>Jharpokharia ,Odisha 757079
          ,india
        </p>
        <p><i class="fa fa-envelope mr-3"></i> Jharpokharia@gmail.com</p>
        <p><i class="fa fa-phone mr-3" aria-hidden="true"></i> + 99999999998</p>
        <p><i class="fa fa-phone mr-3"></i> + 88888888889</p>
      </div>
      <!-- Grid column -->
    </div>
    <!-- Grid row -->
  </div>
  <!-- Footer Links -->

  <!-- Copyright -->
  <div class="footer-copyright text-center text-black-50 py-3">
    © 2021 Copyright:
    <a class="dark-grey-text" href="https://texiant.com/"> texiant.com</a>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
